import { isMobile } from '@pascal/pascal-core';
import { degreesToRadians } from './utils';

export const DIRECTIONS = {
  RIGHT: 'right',
  LEFT: 'left',
};

export const SCENE_OBJ_NAMES = {
  ball: "ball",
  scene: "scene",
  camera: "camera",
  rouletteDisk: "rouletteDisk",
  rouletteRoom: "rouletteRoom",
};

// export const cameraPos1 = {
//   position: { x: 0.0505116157814505, y: 1.6882800248142087, z: 2.5150763159083596 },
//   rotation: { x: -0.3714589766896149, y: 0.02045795371898196, z: 0.007968519430331797 },
// };
//
// export const cameraPos2 = {
//   position: { x: 0.025234993565845673, y: 1.779467311740751, z: 0.702098205854405 },
//   rotation: { x: -1.0781956695089223, y: 0.037936436639319025, z: 0.07054601503421067 },
// };

export const mobileCameraPos2 = {
  position: {
    x: 0,
    y: 1.50,
    z: 0.44,
  },
  rotation: {
    x: degreesToRadians(-61.53),
    y: degreesToRadians(0.51),
    z: degreesToRadians(0.94),
  },
};

export const cameraPos1 = {
  position: { x: 0.0505116157814505, y: 1.6882800248142087, z: 2.5150763159083596 },
  rotation: { x: -0.3714589766896149, y: 0.02045795371898196, z: 0.007968519430331797 },
};

export const cameraPos2 = isMobile()
    ? mobileCameraPos2
    : {
      position: { x: 0.025234993565845673, y: 1.779467311740751, z: 0.702098205854405 },
      rotation: { x: -1.0781956695089223, y: 0.037936436639319025, z: 0.07054601503421067 },
    };


export const STANDARD_FPS = 60;

export const rouletteNumbersArrangement = [0, 26,  3, 35, 12, 28, 7, 29, 18, 22, 9, 31, 14, 20, 1, 33, 16, 24, 5, 10, 23, 8, 30, 11, 36, 13, 27, 6, 34, 17, 25, 2, 21, 4, 19, 15, 32];

export const perNumberAngle = 360 / rouletteNumbersArrangement.length;

